export default {
  // 공통
  common: {
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    add: '추가',
    search: '검색',
    reset: '초기화',
    export: '내보내기',
    import: '가져오기',
    upload: '업로드',
    download: '다운로드',
    submit: '제출',
    back: '뒤로',
    next: '다음',
    previous: '이전',
    close: '닫기',
    refresh: '새로고침',
    loading: '로딩 중...',
    success: '작업 성공',
    error: '작업 실패',
    warning: '경고',
    info: '정보'
  },
  
  // 로그인
  login: {
    title: '사용자 로그인',
    username: '사용자명',
    password: '비밀번호',
    login: '로그인',
    logout: '로그아웃',
    loginSuccess: '로그인 성공',
    loginFailed: '로그인 실패',
    notLoggedIn: '로그인되지 않음...',
    systemTitle: '청화환경기술·수소발생기 관리시스템',
    welcomeTitle: '환영합니다 - 수소발생기 관리시스템',
    usernameMinLength: '사용자명은 최소 2자 이상이어야 합니다',
    passwordFormat: '비밀번호 형식이 올바르지 않습니다',
    verificationCode: '인증 코드 오류 (대소문자 구분)'
  },
  
  // 관리자 페이지
  admin: {
    title: '청화환경기술-관리시스템',
    dashboard: '대시보드',
    menu: '메뉴',
    logout: '로그아웃'
  },
  
  // 디바이스 관리
  device: {
    title: '디바이스 관리',
    list: '디바이스 목록',
    add: '디바이스 추가',
    edit: '디바이스 편집',
    delete: '디바이스 삭제',
    status: '디바이스 상태',
    type: '디바이스 유형',
    online: '온라인',
    offline: '오프라인',
    heartbeat: '하트비트 데이터',
    record: '작업 기록',
    activate: '활성화 기록'
  },
  
  // 조직 관리
  org: {
    title: '조직 관리',
    list: '조직 목록',
    add: '조직 추가',
    edit: '조직 편집',
    delete: '조직 삭제',
    name: '조직명',
    code: '조직 코드',
    type: '조직 유형'
  },
  
  // 물 카드 관리
  card: {
    title: '물 카드 관리',
    list: '물 카드 목록',
    add: '물 카드 추가',
    bind: '물 카드 바인딩',
    unbind: '물 카드 언바인딩',
    import: '물 카드 가져오기',
    export: '물 카드 내보내기',
    serialNo: '시리얼 번호',
    cardNo: '카드 번호',
    status: '상태'
  },
  
  // 시스템 설정
  setting: {
    title: '시스템 설정',
    general: '일반 설정',
    security: '보안 설정',
    notification: '알림 설정'
  },
  
  // 데이터 통계
  stats: {
    title: '데이터 통계',
    tds: 'TDS 통계',
    volume: '물량 통계',
    usage: '사용 통계'
  },
  
  // 푸터
  footer: {
    copyright: '© 2023 - 청화환경기술유한공사 모든 권리 보유',
    icp: 'ICP 기록: ',
    techSupport: '© 기술 지원: 광저우 관군 수소 기술 유한공사'
  },
  
  // 오류 메시지
  error: {
    network: '네트워크 오류',
    server: '서버 오류',
    permission: '권한 부족',
    param: '매개변수 오류',
    notFound: '데이터를 찾을 수 없음',
    pageNotFound: '죄송합니다. 방문하신 페이지가 존재하지 않습니다'
  },
  
  // 메뉴 관련
  menu: {
    // 디바이스 관리
    equipment: '디바이스 및 필터 라이브러리',
    filterRecord: '필터 교체 기록',
    version: '홈 버전 라이브러리',
    dataQuery: 'TCP 데이터 쿼리',
    heartbeat: '하트비트 데이터',
    singleUse: '단회 사용 데이터',
    bindStats: '바인딩 통계',
    
    // 고객 관리
    customer: '고객 관리',
    agentCheck: '에이전트 검토',
    agentProfit: '에이전트 수익 관리',
    promotionRoute: '프로모션 경로 구성',
    partyType: '파티 타입 관리',
    
    // MQTT 데이터 쿼리
    mqttQuery: 'MQTT 데이터 쿼리',
    statusQuery: '상태 쿼리',
    outputRecord: '출력 기록 쿼리',
    debug: '디바이스 디버그 페이지',
    waterTotal: '총 물 출력 쿼리',
    
    // 시스템 관리
    adminAccount: '관리자 계정',
    deviceType: '디바이스 타입 관리',
    defaultSettings: '기본 시스템 설정',
    flowConfig: '물 흐름 개인화',
    waterConfig: '온도 물 구성',
    businessLog: '비즈니스 로그',
    
    // 결제 관리
    payment: '결제 관리',
    order: '주문 관리',
    statistics: '데이터 통계',
    waterPrice: '물 가격 구성',
    recharge: '충전'
  }
}
